import React from 'react';

const PostTripProcess = {
  title: 'Post-Trip Process',
  items: [
    {
      header: 'What do I have to do after the trip ends?',
      content: (
        <div>
          <p>After the end of your trip, please release the payment for your Local Expert. Then leave a review to share your wonderful experience with other travelers. Your review is invaluable for both your Local Expert and us!</p>
        </div>
      )
    },
    {
      header: 'How can I claim a refund?',
      content: (
        <div>
          <p>Any refund request must be made no later than 2 days after the trip day. It has to be submitted together with a solid reason for refund or other proofs to <a href="mailto:support@takemetour.com">support@takemetour.com</a></p>
        </div>
      )
    }
  ]
};

export default PostTripProcess;
